export const filterBySearchText = (items, key, searchText) => {
    if (!searchText) {
        return items;
    }
    const searchLower = searchText.toLowerCase();
    return items.filter((item) => String(item[key]).toLowerCase().includes(searchLower));
};
//# sourceMappingURL=AutocompleteMultiSelectUtils.js.map